<div class="modal-holder">
    <div class="modal-header">
        <h4 class="modal-title">Logout</h4>
        <button type="button" class="close modalClose" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>{{ message }}</p>
        <div class="change-holder">
            <div *ngFor="let change of changes" class="change">
                <span class="name">{{ change.name }}:</span>
                <span *ngFor="let client of change.clients" class="badge badge-light">
                    {{ client.name }}
                </span>
            </div>
        </div>
        <hr>
        <div class="btn-group">
            <button type="button" class="ct-btn secondary-btn mr-3" ngbAutofocus
                (click)="activeModal.close()">Cancel</button>
            <button type="button" class="ct-btn primary-btn margin-right" (click)="activeModal.close('Logout')">Logout</button>
        </div>
    </div>
</div>